import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import ContactsDataGrid from '../../../Contacts/Page/ContactsDataGrid'
import { MemberStatus } from '../../../../utils/enums';
import useApiManager from '../../../../utils/Api/apiManager';
import { toast } from 'sonner';

const ContactsDialog = ({ open, setOpen, campaignId, fetchContacts, fetchCampaignRelatedEntitiesCount }) => {
    const [selectedRows, setSelectedRows] = useState(null); // State to store selected row ID
    const { post } = useApiManager();
    const [memberStatus, setMemberStatus] = useState(0);

    const handleClose = () => {
        setOpen(false);
    };

    // Handler to capture selected row ID
    const handleSelectionChange = (newSelection) => {
        setSelectedRows(newSelection); // Store selected row IDs
    };

    const handleAddContact = async () => {
        if (selectedRows < 1) {
            alert("Please select a row!");
            return;
        }
        try {
            const responseData = await post(`/leadcampaigns/add-leads-to-campaign`, {
                campaignId: campaignId,
                leadIds: selectedRows,
                memberStatus: memberStatus,
                isContact: true
            });
            // console.log('Form Submitted Successfully:', responseData);
            handleClose();
            fetchContacts();
            fetchCampaignRelatedEntitiesCount();

            // Handle success (e.g., show a notification, redirect, etc.)
        } catch (error) {
            console.error('Failed to submit form:', error);
            // Handle error (e.g., show an error message)
        }
    };
    return (
        <Dialog
            fullWidth
            maxWidth={'md'}
            open={open}
            onClose={handleClose}
        >
            <DialogTitle>Choose Contact</DialogTitle>
            <DialogContent>
                <Box sx={{ height: 300, overflow: 'auto' }}>
                    <ContactsDataGrid
                        onSelectionModelChange={handleSelectionChange}
                        campaignId={campaignId} />
                </Box>

                <Autocomplete
                    disablePortal
                    options={MemberStatus}
                    value={MemberStatus.find((option) => option.value === memberStatus)}
                    size="small"
                    sx={{ width: "20%", mt: 2 }}
                    onChange={(event, newValue) => setMemberStatus(newValue ? newValue.value : '')}
                    renderInput={(params) => <TextField {...params} label="Member Status" />}
                />

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Close</Button>
                <Button onClick={handleAddContact}>Add Contact</Button>
            </DialogActions>
        </Dialog>
    )
};

export default ContactsDialog;